export default __webpack_public_path__ + "static/media/logo.858991a6.svg";